/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProductApprovalCheckStepDto } from './ProductApprovalCheckStepDto';
export type ProductApprovalTechnicalExaminationCheckStepDto = (ProductApprovalCheckStepDto & {
    state?: ProductApprovalTechnicalExaminationCheckStepDto.state;
});
export namespace ProductApprovalTechnicalExaminationCheckStepDto {
    export enum state {
        OPEN = 'OPEN',
        REJECTED = 'REJECTED',
        APPROVED = 'APPROVED',
    }
}

